<template>
  <div class="hotelCard__item" :class="{'activate': isActive}">
    <div v-if="tourData.imageUrl" class="hotelCard__item__cover cursor-pointer">
      <div class="image" v-lazy:background-image="tourData.imageUrl"></div>
    </div>
    <div class="hotelCard__item__info">
      <div class="hotelCard__item__basic overflow-hidden relative">
        <h6 class="font-semibold mb-4 text-orange-dark text-sm">{{ tourData.typeText }}</h6>
        <a class="hotelCard__link inline-block text-grey-darkest" @click="gotoTours(tourData.externalData)">
          <h6 class="hotelCard__name">{{ tourData.languageData.name }}</h6>
        </a>
        <div v-if="tourData.administrativeAreaName" class="text-xs mt-8">
          <span>{{ tourData.administrativeAreaName }}</span>
        </div>
        <div v-if="tourData.saleCount > 0" class="sale-info">
          {{ $t('mapCard.soldAmount', [tourData.saleCount]) }}
        </div>
      </div>
      <div class="flex items-end justify-end ml-16">
        <div class="text-right">
          <div v-if="tourData.ranking" class="hotelCard__ranking mb-8">
            <i class="text-orange-light owl-rank-star mr-4"></i>
            <span>{{ tourData.ranking }}</span>
          </div>
          <div v-if="!tourData.inStock" class="font-semibold text-sm text-right">
            <span class="text-red-dark font-bold ml-8">{{ $t('soldOut') }}</span>
          </div>
          <div v-else-if="tourData.price && Number(tourData.price) > 0" class="font-semibold text-grey-darkest text-lg text-right">
            <span v-if="tourData.currency">{{ currencySign }}</span>
            <span class="ml-8">{{ Number(tourData.price) | currencyConvert({ inputCurrency: tourData.currency, listInteger: true }) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'tourCard',
  props: {
    tourData: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/currencySign'
    })
  },
  methods: {
    gotoTours: function (tourId) {
      if (this.isActive) {
        window.open(`https://www.owlting.com/experiences/products/${tourId}`, '_blank')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.hotelCard
  &__item
    @apply p-8
    @apply bg-white border-1 border-grey-lighter rounded
    @apply flex flex-row
    width: 100%
    // min-width: 300px
    cursor: move
    cursor: grab
    cursor: -moz-grab
    cursor: -webkit-grab
    @apply border-t-1
    min-height: 130px
    &:hover
      @apply shadow
    &:active
      cursor: grabbing
      cursor: -moz-grabbing
      cursor: -webkit-grabbing
    &.activate
      @apply border-2 border-grey-darker rounded shadow
    &__cover
      width: 107px
      @apply mr-16
      .image
        @apply h-full rounded-sm
        padding-top: imageRatio(130, 100)
        background:
          position: center
          repeat: no-repeat
          size: cover
    &__info
      @apply overflow-hidden flex flex-1 flex-col justify-between items-stretch
    &__basic
      @apply flex-1 w-full
  &__link
    max-width: 100%
    text-decoration: none
    &:hover
      text-decoration: underline
  &__name
    @apply font-semibold leading-md overflow-hidden
    max-height: 36px
    line-height: 1.3
  &__ranking
    @apply hidden
  @screen lg
    &__item
      min-width: 550px
      &__info
        @apply flex-row
        .sale-info
          @apply absolute flex mt-16 pin-b
      &__basic
        @apply w-4/5
    &__ranking
      @apply block
</style>
